
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Maximal eine von 20 Frauen leidet an reiner «menstrueller Migräne». Diese setzt
ein, wenn der Spiegel des weiblichen Geschlechtshormons Östrogen absinkt, also
etwa 2 Tage vor der Mens bis 3 Tage nach ihrem Beginn. Häufiger ist die
«menstruell-assoziierte Migräne», die bei der Mens, aber auch zwischendrin
auftritt. Die Gebärmutter- oder die Eierstöcke entfernen zu lassen, nützt
übrigens nichts.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;